import { useQuery } from "@tanstack/react-query";
import { queryClient } from "shared/api/queryClient";
import { getArticlesGroupList } from "../api/getArticlesGroupList";
import { ArticleBrandId, ArticleCategory, ArticleGroupIds } from "../types";

export const GROUP_ARTICLES_QUERY_KEY = "group-articles-list";

export const articleGroupListQueryKey = (params: Params) => [
  GROUP_ARTICLES_QUERY_KEY,
  params,
];

type Params = {
  brandId: ArticleBrandId;
  categoryId: ArticleCategory;
  groupId: ArticleGroupIds;
};

export const useArticleGroupListQuery = ({
  brandId,
  categoryId,
  groupId,
}: Params) => {
  return useQuery({
    queryKey: articleGroupListQueryKey({ brandId, categoryId, groupId }),
    queryFn: async () => {
      const data = await getArticlesGroupList(brandId, categoryId, groupId);

      return data;
    },
  });
};

export const invalidateArticleGroupListQuery = ({
  brandId,
  categoryId,
  groupId,
}: Params) => {
  return queryClient.invalidateQueries({
    queryKey: articleGroupListQueryKey({ brandId, categoryId, groupId }),
  });
};
